import { AxiosResponse } from "axios";
import { apiInstance } from "@/store/configureStore";

export const deleteNewsCommentsRequest = async (id: number) => {
  const response: AxiosResponse = await apiInstance.delete(
    `/news/comments/${id}`
  );

  return response.data;
};
